import React, { Component } from "react";

const selectedTextStyle = {
  color: `white`,
};

const normalTextStyle = {
  color: `#2CC84D`,
};

const buttonStyle = {
  backgroundColor: "#2CC84D",
};

class ShopCategoryItem extends Component {
  /**
   * Properties
   */
  get itemKey() {
    return this.props.key;
  }

  get itemName() {
    return this.props.text;
  }

  /**
   * Events
   */

  onSelectedItemClick() {
    if (this.props.toggleMode) {
      this.setState({ selected: false }, () => {
        this.props.onClick(false);
      });
    } else {
      this.props.onClick(false);
    }
  }

  onNoSelectedItemClick() {
    this.setState({ selected: true }, () => {
      this.props.onClick(true);
    });
  }

  /**
   * Render
   */
  render() {
    return this.props.selected ? (
      <div
        className="d-inline-block border rounded28 px-2 py-1 small ms-2 mb-0 h-100"
        style={buttonStyle}
        key={this.itemKey}
        onClick={() => {
          this.onSelectedItemClick();
        }}
      >
        <span style={selectedTextStyle}>{this.itemName}</span>
      </div>
    ) : (
      <div
        className="d-inline-block border rounded28 px-2 py-1 small ms-2 mb-0 h-100"
        key={this.itemKey}
        onClick={() => {
          this.onNoSelectedItemClick();
        }}
      >
        <span style={normalTextStyle}>{this.itemName}</span>
      </div>
    );
  }
}

ShopCategoryItem.defaultProps = {
  selected: false,
  toggleMode: false,
};

export default ShopCategoryItem;
